import React, { PureComponent } from 'react'
import compose from 'recompose/compose'

import { Select, Icon } from "@driftt/tide-core-legacy"

import SingleParticipantAction from './SingleParticipantAction'
import GroupParticipantAction from './GroupParticipantAction'
import TeamParticipantAction from './TeamParticipantAction'

import {
  ACTION_TYPES,
  PARTICIPANT_ADD_TYPES
} from 'app/modules/rules/constants'

import {
  PARTICIPANT_TYPES,
  PARTICIPANT_TYPE_OPTIONS
} from './constants'

import withOrgTeams from 'app/modules/teams/hoc/withOrgTeams'

import './style'


class ParticipantActions extends PureComponent {

  constructor(props) {
    super(props)

    this.state = {
      selectedValue: this.getParticipantTypeFromAction() || PARTICIPANT_TYPES.SINGLE
    }
  }

  getParticipantTypeFromAction = () => {
    const action = this.props.rule.data.item.action

    if (action.options.teamId) {
      return PARTICIPANT_TYPES.TEAM
    }
    else if (action.options.userIds.length === 1) {
      return PARTICIPANT_TYPES.SINGLE
    }
    else if (action.options.userIds.length > 1) {
      return PARTICIPANT_TYPES.GROUP
    }
  }

  onParticipantTypeChanged = (selectedOption) => {
    this.setState({ selectedValue: selectedOption.value })
  }

  setActionParticipants = ({ participants, participantType }) => {
    const { setPageValidity, updateAction } = this.props
    const { action } = this.props.rule.data.item

    if (participantType === PARTICIPANT_TYPES.SINGLE || participantType === PARTICIPANT_TYPES.GROUP) {
      const isValid = action.options.addType && participants.length > 0
      setPageValidity(isValid)

      if (isValid) {
        updateAction({
          type: ACTION_TYPES.PARTICIPANT,
          options: {
            isAccountOwner: true,
            addType: action.options.addType,
            userIds: participants
          }
        })
      }
    }

    if (participantType === PARTICIPANT_TYPES.TEAM) {
      const isValid = !!participantType && participants.length > 0

      setPageValidity(isValid)

      if (isValid) {
        updateAction({
          type: ACTION_TYPES.PARTICIPANT,
          options: {
            isAccountOwner: true,
            addType: PARTICIPANT_ADD_TYPES.ONE,
            teamId: participants[0],
          }
        })
      }
    }
  }

  renderSelectOption = ({ label, value }) => {
    const iconName = value === PARTICIPANT_TYPES.SINGLE ? 'user-circle' : 'team-2'

    return (
      <div className="participant-type-dropdown-option">
        <Icon height={14} width={14} name={iconName}/>
        <span >{label}</span>
      </div>
    )
  }

  renderParticipantActionType = () => {
    const { selectedValue } = this.state

    switch (selectedValue) {
      case PARTICIPANT_TYPES.SINGLE:
        return (<SingleParticipantAction {...this.props} setActionParticipants={this.setActionParticipants}/>)
      case PARTICIPANT_TYPES.GROUP:
        return (<GroupParticipantAction {...this.props} setActionParticipants={this.setActionParticipants}/>)
      case PARTICIPANT_TYPES.TEAM:
        return (<TeamParticipantAction {...this.props} setActionParticipants={this.setActionParticipants}/>)
      default:
        return null
    }
  }

  render() {
    return (
      <div className="participant-actions">
        <header>
          <h1>Choose participants to add</h1>
          <p>Select which teammate(s) you want to add to a conversation as a participant.</p>
        </header>
        <div className="participant-action-selector">
          <div className="participant-action-selector-description">How do you want to add participants?</div>
          <Select
            multi={false}
            options={PARTICIPANT_TYPE_OPTIONS}
            optionRenderer={this.renderSelectOption}
            valueRenderer={this.renderSelectOption}
            onChange={this.onParticipantTypeChanged}
            autoFocus={true}
            clearable={false}
            value={this.state.selectedValue}
          />
          <p>Automatically add one user or account owner to each new conversation. If you choose a team, one member from the team will automatically be added to each conversation. </p>
        </div>
        <div>
          {this.renderParticipantActionType()}
        </div>
      </div>
    )
  }

}

export default compose(withOrgTeams)(ParticipantActions)



// WEBPACK FOOTER //
// ./src/scripts/components/settings/Rules/components/ActionEditor/ParticipantActions/index.js